import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { v1 } from 'uuid';
import { PropTypes as PropTypes$1 } from '@micromag/core';
import { getStyleFromMargin } from '@micromag/core/utils';

var styles = {"container":"micromag-element-link-container"};

var propTypes = {
  url: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string,
  external: PropTypes.bool,
  margin: PropTypes$1.margin,
  className: PropTypes.string,
  children: PropTypes.node,
  focusable: PropTypes.bool
};
var defaultProps = {
  url: null,
  target: null,
  rel: null,
  external: true,
  margin: null,
  className: null,
  children: null,
  focusable: true
};
var Link = function Link(_ref) {
  var url = _ref.url,
    linkTarget = _ref.target,
    linkRel = _ref.rel,
    external = _ref.external,
    margin = _ref.margin,
    className = _ref.className,
    children = _ref.children,
    focusable = _ref.focusable;
  var finalStyle = null;
  if (margin !== null) {
    finalStyle = _objectSpread(_objectSpread({}, finalStyle), getStyleFromMargin(margin));
  }
  var id = useMemo(function () {
    return finalStyle !== null ? "link-component-".concat(v1()) : null;
  }, [finalStyle !== null]);
  var _ref2 = external ? {
      target: '_blank',
      rel: 'noopener noreferer'
    } : {
      target: linkTarget,
      rel: linkRel
    },
    target = _ref2.target,
    rel = _ref2.rel;
  return url ? /*#__PURE__*/React.createElement("a", {
    id: id,
    className: classNames([styles.container, _defineProperty({}, className, className !== null)]),
    style: finalStyle,
    href: url,
    target: target,
    rel: rel,
    tabIndex: focusable ? '0' : '-1'
  }, children) : /*#__PURE__*/React.createElement("div", {
    id: id,
    className: classNames([styles.container, _defineProperty({}, className, className !== null)]),
    style: finalStyle
  }, children);
};
Link.propTypes = propTypes;
Link.defaultProps = defaultProps;

export { Link as default };
